/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "antd/dist/reset.css";
import "../../containers/customLayout.css";
import "../../App.css";
import { programmes } from "../../utils/apiConstants";

import {
  Col,
  Row,
  Image,
  Divider,
  Select,
  Card,
  Result,
  Skeleton,
  Button,
  Pagination,
} from "antd";
import ProgrammeSubscription from "../programme/ProgrammeSubscription";

import service from "../../services/citizenscienceService";
import citizenLookup from "../../services/citizenScienceLookupService";
import { recordError } from "src/utils/logService";
import { Link, useNavigate } from "react-router-dom";
import commonLookupService from "src/services/commonLookupService";
import {
  CheckCircleOutlined,
  CheckOutlined,
  ChromeOutlined,
  CloseCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import { login } from "../../security/AppSecurity";

const CitizenScienceView = ({ props }) => {
  const programme = programmes.find((p) => p.key === "citizen-science");
  const [isEmptyResults, setIsEmptyResults] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [projectLink, setProjectLink] = useState("project/details");
  const [isResultReady, setIsResultReady] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");

  const [filterCategory, setFilterCategory] = useState();
  const [filterProvince, setFilterProvince] = useState();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(8);
  const [firstRecord, setFirstRecord] = useState(0);
  const [total, setTotal] = useState(0);

  const [projects, setProjects] = useState([]);
  const [domains, setDomains] = useState([]);

  const [provinces, setProvinces] = useState([]);
  const navigate = useNavigate();

  // console.log("filteredData: " , filteredData[1].locations.map(loc => loc.town.value + " " + loc.province.value));

  const { Option } = Select;

  useEffect(() => {
    getScienceDomains();
    getprovinceData();
    getRatifiedProjects({ first: 0, pageSize: 8 });
  }, []);

  const clearFilters = (e) => {
    e.preventDefault();
    setFilterCategory("All Categories");
    setFilterProvince("All Provinces");
    setFirstRecord(0);
    setCurrentPage(1);
    getRatifiedProjects({ first: 0, pageSize: 8, location: "", domain: "" });
  };
  const onPageChange = (page, pageSize) => {
    const first = (page - 1) * pageSize;
    setFirstRecord(first);
    setCurrentPage(page);
    getRatifiedProjects({ first: first, pageSize: pageSize });
  };

  const onShowSizeChange = (page, size) => {
    const first = (page - 1) * size;
    setFirstRecord(first);
    setCurrentPage(page);
    setPageSize(size);
    getRatifiedProjects({ first: first, pageSize: size });
  };

  const getRatifiedProjects = async ({
    first = firstRecord,
    max = pageSize,
    domain = selectedCategory,
    location = selectedProvince,
  }) => {
    try {
      const response = await service.getRatifiedProjects({
        first: first,
        max: max,
        domain: domain,
        location: location,
      });
      if (response && response.status === 200) {
        const { data } = response;
        let projectData = data.results?.map((element) => ({
          key: element.uuid,
          name: element.name,
          description: element.description,
          locations: element.locations,
          allowParticipation: element.allowParticipation,
          domains: element.domains,
        }));
        setProjects(projectData);
        setFilteredData(projectData);
        setIsResultReady(true);
        setTotal(data.total);
      } else {
        setProjects([]);
        setFilteredData([]);
        setTotal(0);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getScienceDomains = async () => {
    try {
      const response = await citizenLookup.getScienceDomains();
      if (response && response.status === 200) {
        const { data } = response;
        const allCategories = { key: -1, value: "All Categories" };
        data.unshift(allCategories);
        setFilterCategory(allCategories.value);
        setDomains(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getprovinceData = async () => {
    try {
      const response = await commonLookupService.getProvincesDistrictTowns();
      if (response && response.status === 200) {
        const { data } = response;
        const allProvince = { key: -1, value: "All Provinces" };
        data.unshift(allProvince);
        setFilterProvince(allProvince.value);
        setProvinces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const loginView = () => {
    navigate("/login");
  };

  const onDomainChange = (key) => {
    getRatifiedProjects({ domain: key });
    setFilterCategory(key);
    setSelectedCategory(key);
    setFirstRecord(0);
    setCurrentPage(1);
    // try {
    //   if (key === undefined) {
    //     setFilteredData(projects);
    //     return;
    //   }
    //   const keyValue = domains.find((domain) => domain.key == key)
    //   var dataf = projects.filter(data => data.domains.some(domain => domain.key == keyValue.key));
    //   setFilteredData(dataf);
    //   setDefaultValue(dataf);
    // } catch (error) {
    //   recordError(error);
    // }
  };

  const onProvinceChange = (key) => {
    getRatifiedProjects({ location: key });
    setFilterProvince(key);
    setSelectedProvince(key);
    setFirstRecord(0);
    setCurrentPage(1);
    // try {
    //   if (key === undefined) {
    //     setFilteredData(projects);
    //     return;
    //   }
    //   const keyValue = provinces.find((prov) => prov.key == key)
    //   var dataf = projects.filter(data => data.locations.some(prov => prov.province.key == keyValue.key));
    //   setFilteredData(dataf);
    // } catch (error) {
    //   recordError(error);
    // }
  };
  return (
    <div>
      <Row>
        <Col xs={24}>
          <div className="center-align">
            <Image
              src={require("../../assets/citizen science landing.png")}
              alt="Citizen Science"
              preview={false}
            />
          </div>
        </Col>
      </Row>

      <div className="middle-content">
        <Row>
          <Col xs={24}>
            <div className="public-portal-section">
              <h2> Citizen Science</h2>
            </div>
          </Col>
        </Row>
        <Row justify={"center"} style={{ paddingBottom: "20px" }}>
          <Col xs={18}>
            <div>
              <p>
                The Citizen Science Department seeks to connect people with
                biodiversity conservation- and development-related research
                projects and seeks to help orchestrate that research,
                disseminate the results, and support community action. The
                Citizen Science Department links citizens who have an existing
                interest in biodiversity and development research with
                opportunities where they can volunteer on and contribute to
                long-term research projects. In the process of training and
                assisting students, providing immersive opportunities for
                informal researchers, and collaborating with local communities,
                our mission is to transform all stakeholders into citizen
                scientists.
              </p>
            </div>
          </Col>
        </Row>
        <Row
          justify={"center"}
          style={{ paddingBottom: "20px", paddingTop: "10px" }}
          className="join-project-section"
        >
          <Col xs={14}>
            <div className="public-portal-programme">
              <h2>Want to add your Project to SEIMS?</h2>
            </div>
            <div
              className="project-block"
              style={{ paddingBottom: "10px", paddingTop: "10px" }}
            >
              <Image
                src={require("../../assets/project_icon.png")}
                alt="Citizen Science"
                className="project-icon"
                preview={false}
              />
              <div className="project-desc">
                <p>
                  Are you leading a research project where you are involving
                  members of the public in the scientific research process? If
                  so, register your project now on SEIMS.
                </p>
                <Button
                  className="add-project"
                  type="primary"
                  style={{ borderRadius: "15px" }}
                  onClick={loginView}
                >
                  Add your Project
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <div className="list-of-projects-block">
          <Row style={{ paddingBottom: "10px", paddingTop: "10px" }}>
            <Col xs={24}>
              <div className="public-portal-section">
                <h2> Get Involved - List of Projects</h2>
              </div>
            </Col>
          </Row>
          {/* <Row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Col xs={2} md={2}>
          </Col>
          <Col xs={24} md={1}>
            <b>Filter By </b>
          </Col>
          <Col span={4} >
            <Select
            // showSearch
              allowClear
              style={{ width: "60%" }}
              placeholder="Categories"
              onSelect={onDomainChange}
              onChange={onDomainChange}
               mode="tags"
            >
              {domains.map((domain) => (
                <Option key={domain.key}>{domain.value}</Option>
              ))}
            </Select>
          </Col>
          <Col >
            <Select
              allowClear
              style={{ width: "60%", marginRight: "50px" }}
              placeholder="Province"
              onSelect={onProvinceChange}
              onChange={onProvinceChange}
                             mode="tags"
            >
              {provinces?.map(option => (
                <Option key={option.key}>{option.value}</Option>
              ))}
            </Select>
          </Col>
          <Col>
            <a
              style={{ marginRight: "10px" }}
              href="#"
              // className="applyFilter"
              onClick={(e) => {
                clearFilters(e);
              }}
            >
              Clear applied filters
            </a>
          </Col>
        </Row> */}

          <div>
            <Row>
              &nbsp;&nbsp;
              <Col span={1}></Col>
              <Col span={2}></Col>
              <Col>
                <span>Filter By &nbsp;</span>
              </Col>
              <Col>
                <Select
                  // showSearch
                  // allowClear
                  style={{ width: 200 }}
                  onChange={onDomainChange}
                  value={filterCategory}
                >
                  {domains.map((domain) => (
                    <Option key={domain.key}>{domain.value}</Option>
                  ))}
                </Select>
              </Col>
              <Col>
                <Select
                  // showSearch
                  // allowClear
                  style={{ width: 200, marginLeft: "10px" }}
                  onChange={onProvinceChange}
                  value={filterProvince}
                >
                  {provinces?.map((option) => (
                    <Option key={option.key}>{option.value}</Option>
                  ))}
                </Select>
              </Col>
              <Col>
                <a
                  style={{
                    marginLeft: "10px",
                    color: "#54AAEE",
                    fontWeight: "bold",
                  }}
                  href="#"
                  // className="applyFilter"
                  onClick={(e) => {
                    clearFilters(e);
                  }}
                >
                  Clear applied filters
                </a>
              </Col>
            </Row>
          </div>
          <Row justify="center">
            <Col lg={18} md={20} xs={24}>
              <Row gutter={[16, 16]} className="card-section">
                {isResultReady && filteredData && filteredData.length === 0 ? (
                  <Card className="" bordered={true}>
                    <div className="" style={{ textAlign: "center" }}>
                      <Image
                        style={{ width: "30%", height: "50%" }}
                        className=""
                        src={require("../../assets/no-results.jpg")}
                        alt="Results not found image"
                        preview={false}
                      />
                      <Result title="Sorry,we couldn't find any results, please try again using a different search criteria." />
                    </div>
                  </Card>
                ) : (
                  // filteredData.length > 0 && filteredData.slice(minValue, minValue + pageSize).map((item, index) => (
                  filteredData.length > 0 &&
                  filteredData.map((item, index) => (
                    <Col
                      className="project"
                      key={index}
                      xs={24}
                      sm={12}
                      md={8}
                      lg={6}
                    >
                      <Card className="guide-card">
                        <div className="pp" style={{ fontSize: "16px" }}>
                          <b>{item.name}</b>
                        </div>
                        <div className="p">{item.description}</div>

                        <div className="pi">
                          {item.allowParticipation ? (
                            <>
                              <Image
                                src={require("../../assets/approval-icon.png")}
                                alt="Accepting Application Icon"
                                preview={false}
                              />{" "}
                              &nbsp;Accepting applications
                            </>
                          ) : (
                            <>
                              <Image
                                src={require("../../assets/cancel-icon.png")}
                                alt="Not Accepting Application Icon"
                                preview={false}
                              />
                              &nbsp;Not Accepting applications
                            </>
                          )}
                        </div>
                        <div className="pu">
                          <span className="location-icon">
                            <Image
                              src={require("../../assets/location-icon.png")}
                              alt="Not Accepting Application Icon"
                              preview={false}
                            />
                          </span>{" "}
                          <div className="l">
                            {item.locations?.map((loc) => ( 
                               <>
                                  &nbsp;{loc.town.value + " , " + loc.province.value} 
                                <br />
                               </> 
                             ))} 
                          </div>
                        </div>
                        <div className="pt">
                          <span className="location-icon domain-icon">
                            <Image
                              src={require("../../assets/shutter-icon.png")}
                              alt="Not Accepting Application Icon"
                              preview={false}
                            />
                          </span>
                          <div className="location">
                             {item.domains?.map((dom) => dom.value).join(" , ")}
                          </div>
                        </div>

                        {/* <div className="pi">{item.allowParticipation ? <><CheckCircleOutlined style={{ color: "green", fontSize: '16px' }} /> Accepting applications</> : <><CloseCircleOutlined style={{ color: "red", fontSize: '16px' }} /> Not Accepting applications</>}</div>
                        <div className="pu"><span className="location-icon"><EnvironmentOutlined style={{ color: "#2E86C1", fontSize: '16px' }} /></span> <div className="location">{item.locations?.map(loc => (<>{loc.town.value + " , " + loc.province.value}<br /></>))}</div></div>
                        <div className="pt"><span className="location-icon"><ChromeOutlined style={{ color: "#F5B041", fontSize: '16px' }} /></span><div className="location"> {item.domains?.map(dom => dom.value).join(" , ")}</div></div> */}
                        <br />

                        <div className="" style={{ textAlign: "center" }}>
                          <Button
                            className="projectButton"
                            type="primary"
                            style={{ borderRadius: "15px" }}
                          >
                            <Link
                              to={`/${projectLink}/${item.key}`}
                              state={{ from: "/${projectLink}", data: item }}
                            >
                              View Details
                            </Link>
                          </Button>
                        </div>
                      </Card>
                    </Col>
                  ))
                )}
              </Row>
            </Col>
          </Row>
          <Row justify={"center"} style={{ paddingBottom: "20px" }}>
            <Col xs={18}>
              {!isEmptyResults && (
                <Pagination
                  defaultCurrent={1}
                  current={currentPage}
                  defaultPageSize={pageSize}
                  onChange={onPageChange}
                  total={total}
                  showSizeChanger
                  onShowSizeChange={onShowSizeChange}
                  pageSizeOptions={[2, 4, 8]}
                  pageSize={pageSize}
                  showQuickJumper
                  showTotal={(total, range) =>
                    `Showing ${range[0]}-${range[1]} of ${total} results`
                  }
                />
              )}
            </Col>
          </Row>
        </div>
      </div>
      {/* <ProgrammeSubscription programme={programme} showButton={true} /> */}
    </div>
  );
};

export default CitizenScienceView;
